import * as React from 'react';
import Button from '@mui/material/Button';
import Spinner from 'react-bootstrap/Spinner';

export default function ButtonComp(props) {

    const {
        title,
        onClick,
        style,
        disable=false,
        loading=false,
        backgroundColor='black'
    } = props;

  return (
      <Button disabled={disable} backgroundColor={'red'} style={{...styles.btn,backgroundColor:(disable)?'#E6E6E6':backgroundColor,...style}} onClick={onClick} variant="contained">
        {(loading)?
          <Spinner animation="border" />
          :title
        }
      </Button>
  );
}

const styles = {
  btn:{
    color:'#FFFFFF',
    fontFamily:'Montserrat',
    paddingTop:10,
    fontSize:17,
    fontWeight:'bold',
    width:'65%',
    height:45,
    borderRadius:20,
  }
}